import { Component, OnInit, ElementRef } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { ProductService } from "../../../shared/services/product.service";
import { Product } from "../../../shared/classes/product";
import { DireccionesService } from "../direcciones/services/direcciones.service";
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-custom-price',
  templateUrl: './modal-custom-price.component.html',
  styleUrls: ['./modal-custom-price.component.scss']
})
export class ModalCustomPriceComponent implements OnInit {

  public products: Product[] = [];
  public isLoaded: boolean = false;
  public tempProducts: Product[] = [];
  public productForm: FormGroup;

  constructor(
    private route: Router,
    private fb: FormBuilder,
    private toastService: ToastrService,
    private activatedRoute: ActivatedRoute,
    public productService: ProductService,
    private direccionesService: DireccionesService,
    private toastr: ToastrService,
    private elRef: ElementRef
  ) {
    this.productForm = this.fb.group({
      products: this.fb.array([])
    });
  }

  ngOnInit() {
    this.traerProductos();
  }

  get productFormArray() {
    return this.productForm.get('products') as FormArray;
  }

  traerProductos() {
    this.productService.cartItems.subscribe((response) => {
      this.products = response;
      this.tempProducts = JSON.parse(JSON.stringify(response));
      this.populateProductForm();
      this.isLoaded = true;
    });
  }

  populateProductForm() {
    this.tempProducts.forEach((product) => {
      this.productFormArray.push(this.fb.group({
        title: [product.title],
        quantity: [product.quantity],
        price: [product.price, Validators.required],
        total: [{ value: product.price * product.quantity, disabled: true }]
      }));
    });
  }

  guardar(): void {
    Swal.fire({
      title: 'Atención',
      text: "¿Estás seguro que deseas personalizar los precios de los productos?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedProducts = this.productForm.value.products;
        this.products.forEach((product, index) => {
          product.price = updatedProducts[index].price;
          product.priceDiscount = product.price;
        });

        localStorage.setItem('cartItems', JSON.stringify(this.products));
        this.closeModal(true, this.products);
        Swal.fire(
          'Precios actualizados',
          '¡Se han actualizado los precios correctamente!',
          'success'
        );
      } else {
        this.closeModal(true, this.products);
      }
    });
  }

  closeModal(reload: boolean, products: any) {
    this.direccionesService.$modalCustomPrice.emit({
      statusModal: false,
      reload: reload,
      products: products
    });
  }

  cerrarModal() {
    this.direccionesService.$modalCustomPrice.emit({
      statusModal: false,
      reload: false,
    });
  }
}
